import { useState } from "react";
import { MdOutlinePix } from "react-icons/md";
import { resolveExtratoItemIcon } from "../../Extrato/baasCdnIcons";

/**
 * TRANSAÇÃO column icon — same patterns as carteira Extrato:
 * circular CDN / Valut balance-icons inside light gray circle.
 * Bank CDN icons keep native colors (no gold CSS filter).
 */
export const BaasTransactionIcon = ({ transaction }) => {
  const [broken, setBroken] = useState(false);
  const resolved = resolveExtratoItemIcon(transaction);
  const isBrandPix =
    resolved && /static\.valut\.app\/balance-icons\/pix\.svg/i.test(resolved);
  const isValutBalanceIcon =
    resolved && /static\.valut\.app\/balance-icons\//i.test(resolved);
  const isCircularCdn =
    !broken &&
    resolved &&
    !isBrandPix &&
    !isValutBalanceIcon &&
    (/cdn\.valut\.services\/assets\/icons\//i.test(resolved) ||
      /\/cdn\/icons\//i.test(resolved));

  return (
    <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-gray-100 dark:bg-[#262626]">
      {resolved && !broken ? (
        <img
          src={resolved}
          alt=""
          onError={() => setBroken(true)}
          className={
            isCircularCdn
              ? "h-9 w-9 rounded-full object-cover"
              : "h-4 w-auto max-w-[18px]"
          }
        />
      ) : (
        <MdOutlinePix className="h-5 w-5 text-[#e7a73f]" aria-hidden />
      )}
    </span>
  );
};
